import React from 'react';
import './Footer.css';
import logo from "../img/assecure_png.png"; // correct relative path


const Footer = () => {
  const currentYear = new Date().getFullYear();

const services = [
  'Web Development',
  'Android Development',
  'Cloud Solutions',
  'Data Analytics',
  'AI & Machine Learning',
  'Blockchain'
];


  const quickLinks = [
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const id = href.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
             <img 
               src={logo} 
                alt="Assecure Logo" 
                className="logo-image"
              />
              <span className="logo-text">assecure</span>
              <span className="logo-dot"></span>
            </div>
            <p className="footer-description">
              Building the future of technology with innovative solutions in Web, Android, Cloud, Data Analytics, AI & Machine Learning, and Blockchain.
            </p>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/assecure/ " className="social-link" aria-label="LinkedIn" target="_blank"
    rel="noopener noreferrer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
             
             
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('#services'); }}>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} onClick={(e) => { e.preventDefault(); scrollToSection(link.href); }}>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-contact">
              <li>
                <span>📧</span>
                <a href="mailto:team.assecure.in@gmail.com">team.assecure.in@gmail.com</a>
              </li>
              <li>
                <span>📞</span>
                <a href="tel:+7058227939">+91 70582 27939</a>
              </li>
              <li>
                <span>📍</span>
                <span>Pune, MH, IN</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} assecure. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <span>|</span>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


